export default {
  link_type: "dedupe_only",
  probability_two_random_records_match: 0.0001,
  blocking_rules_to_generate_predictions: [
    "l.first_name = r.first_name",
    "l.surname = r.surname",
  ],
  comparisons: [
    {
      output_column_name: "First name",
      comparison_levels: [
        {
          sql_condition: "first_name_l IS NULL OR first_name_r IS NULL",
          label_for_charts: "Null",
          is_null_level: true,
        },
        {
          sql_condition: "first_name_l = first_name_r",
          label_for_charts: "Exact match",
          tf_adjustment_column: "first_name",
          tf_minimum_u_value: 0.001,
        },
        {
          sql_condition: "levenshtein(first_name_l, first_name_r) <= 2",
          label_for_charts: "Levenstein <= 2",
          tf_adjustment_column: "first_name",
          tf_minimum_u_value: 0.003,
          tf_adjustment_weight: 0.5,
        },
        {
          sql_condition: "ELSE",
          label_for_charts: "All other comparisons",
        },
      ],
    },
    {
      output_column_name: "Surname",
    },
    {
      output_column_name: "Date of birth",
    },
  ],
  additional_columns_to_retain: ["cluster"],
};
